import {combineReducers} from "redux";
import loginReducer from './modules/login/login-reducer';
import reportReducer from './modules/report/report-reducer';
import reportInfoReducer from './modules/report-info/report-info-reducer';
import chartsReducer from './modules/charts/charts-reducer';
import filtersReducer from "./modules/filters/filters-reducer";
import fullReportTopWordsReducer from "./modules/full-report-top-words/full-report-top-words-reducer";
import fullReportPrimaryOrSentimentReducer from "./modules/full-report-primary-or-sentiment/full-report-primary-or-sentiment-reducer";
import responsesReducer from "./modules/responses/responses-reducer";
import reportsReducer from "./modules/reports/reports-reducer";
import addReportReducer from "./modules/add-report/add-report-reducer";
import notificationsReducer from "./modules/notifications/notifications-reducer";
import wordVerbatimsReducer from "./modules/word-verbatims/word-verbatims-reducer";
import hbIndexChartReducer from "./modules/hb-index-chart/hb-index-chart-reducer";
import addWordsReducer from "./modules/add-words/add-words-reducer";
import selectLabelReducer from "./modules/select-label/select-label-reducer";
import contextMenuReducer from "./modules/context-menu/context-menu-reducer";
import addTaxonomyReducer from "./modules/add-taxonomy/add-taxonomy-reducer";

export default combineReducers({
  login: loginReducer,
  report: reportReducer,
  reportInfo: reportInfoReducer,
  charts: chartsReducer,
  filters: filtersReducer,
  fullReportTopWords: fullReportTopWordsReducer,
  fullReportPrimaryOrSentiment: fullReportPrimaryOrSentimentReducer,
  responses: responsesReducer,
  reports: reportsReducer,
  addReport: addReportReducer,
  notifications: notificationsReducer,
  wordVerbatims: wordVerbatimsReducer,
  hbIndexChart: hbIndexChartReducer,
  addWords: addWordsReducer,
  selectLabel: selectLabelReducer,
  contextMenu: contextMenuReducer,
  addTaxonomy: addTaxonomyReducer
})


// WEBPACK FOOTER //
// ./src/rootReducer.js